import { FC, useEffect } from 'react';
import { useIntl } from 'react-intl';

import { toastCaller } from '@/shared/ui';

import { takeForcedLogoutNotice } from '../../lib';

// Rendered next to the toast container rather than on a page: the landing page
// after a forced logout is not known in advance (sign-up for a new invitee,
// sign-in for an existing one).
export const ForcedLogoutNotice: FC = () => {
  const { formatMessage } = useIntl();

  useEffect(() => {
    if (takeForcedLogoutNotice() !== 'foreignInvitation') {
      return;
    }

    toastCaller({
      type: 'info',
      heading: formatMessage({
        id: 'logout.forced.heading',
        defaultMessage: 'You have been signed out',
      }),
      message: formatMessage({
        id: 'logout.forced.foreignInvitation',
        defaultMessage:
          'The invitation you opened is addressed to another user, so we signed out of the previous account.',
      }),
      autoClose: 10000,
    });
  }, []);

  return null;
};
